import Vue from 'vue'
import { API_ROOT } from '@/config'

const contextPath = 'order-statement'

export default ((<any>Vue).resource(API_ROOT + contextPath + '{/id}', {}))
